import { atomWithStorage } from 'jotai/utils';

// 表示密度のユーザー選択。comfortable=標準 / compact=高密度。
// 表の行高さなど視覚密度のみに反映し、データ・並び順・操作は変えない（C3: 表示のみ）。
// テーマ等と同方針でブラウザ単位・localStorage 永続。
export type Density = 'comfortable' | 'compact';

export const densityAtom = atomWithStorage<Density>(
    'density',
    'comfortable',
    undefined,
    { getOnInit: true },
);
